<template>
    <div class="card" id="smartCatelogCard">
        <div class="card-header mt-3">
            <h5 class="card-title text-center">SmartCatalog Search</h5>
            <hr>
        </div>
        <div class="card-body">
            <div class="row mb-2">
                <div class="col-4">
                    <div class="thumbnail-wrapper">
                        <img v-if="!thumbnailURL" src="@/assets/SmartSalesLogo.png">
                        <img v-if="thumbnailURL" :src="thumbnailURL" class="image" alt="Selected Product Image">
                    </div>
                </div>

                <div class="col-8">
                    <div>
                        <div class="form-group">
                            <select class="form-control"
                                    v-model="selectedCategoryId"
                                    @change="getSubCategories"
                                    >
                                    <option value="-1" disabled selected>Category</option>
                                <option v-for="item in catagories" :key="item.Id" :value="item.Id">{{ item.DisplayName }}</option>
                            </select>
                            <i class="fa fa-chevron-down"></i>
                        </div>
                    </div>

                    <div>
                        <div class="form-group">
                            <select class="form-control"
                                    v-model="selectedSubCategoryId"
                                    @change="getProducts">
                                <option value="-1" disabled selected>Sub-Category</option>
                                <option v-for="item in subcategories" :key="item.Id" :value="item.Id">{{ item.DisplayName }}</option>
                            </select>
                            <i class="fa fa-chevron-down"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="product-datagrid-wrapper">
                <SmartCatalogGrid :dataSource="products"
                               :columns="datagridColumns"
                               :actions="actions"
                               :multiSelect="false"
                               :key="datagridKey"
                               :showColumnSearchIcon="false"
                               :filterByColumn="false"
                               :smartCatalogSearchGrid="true"
                               @addProduct="handleAddProduct"
                               @viewImage="handleViewImage"
                               @viewSmartCatalog="handleViewSpecificProductInSmartCatalog"
                               height="435px"/>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState }   from 'vuex';
    import { LookupService, ProductService }  from '@/services'
    import SmartCatalogGrid from '@/components/SmartCatalogGrid'

    export default {
        name: "SmartCatalogSearchV2",
        data: () => {
            return {
                catagories: [],
                subcategories: [{Id: 0, DisplayName: 'All'}],
                products: [],
                datagridKey: 0,
                selectedCategoryId: -1,
                selectedSubCategoryId: -1,
                selectedManufacturerId: null,
                thumbnailURL: '',
                datagridColumns: [
                    { text: 'Manu.', value: 'MfgCode', width: '100px'},
                    { text: 'Part #', value: 'PartNumber', width: '100px' },
                    { text: 'Product', value: 'Description', width: '400px' },
                    { text: 'Retail', value: 'Retail'}
                ],
            }
        },
        components: {
           SmartCatalogGrid,
        },
        computed: {
            ...mapState(['currentUser']),
            actions(){
                return [
                    {
                        hint: 'Add Product',
                        icon: 'plus',
                        emit: 'addProduct',
                    },
                    {
                        hint: 'SmartCatalog',
                        icon: 'file',
                        emit: 'viewSmartCatalog',
                    },
                    {
                        hint: 'image',
                        icon: 'image',
                        emit: 'viewImage',
                    },
                ]
            }
        },
        methods: {
            getCatagories(){
                LookupService.productCatagories().then(res => {
                    this.catagories = res.sort(function(a, b) {
                        var textA = a.DisplayName.toUpperCase();
                        var textB = b.DisplayName.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    });

                    this.catagories.unshift({
                        Id: 0,
                        DisplayName: '(SHOW ALL)'
                    })
                }).catch(err => {
                    console.error(err);
                })
            },
            getSubCategories() {
                LookupService.productSubcategories(this.selectedCategoryId).then(res => {
                    const allOption = {Id: 0, DisplayName: 'All'}
                    this.subcategories = [allOption].concat(res)
                    this.selectedSubCategoryId = 0;

                    this.getProducts()
                })
            },
            getProducts(){
                this.thumbnailURL = null
                this.products = []

                if (this.selectedSubCategoryId > 0) {
                    LookupService.productCategorySubCategoryProducts(this.selectedCategoryId, this.selectedSubCategoryId)
                    .then(res => {
                        this.products = res ?? [];

                        for(let prod of this.products) {
                            prod.Description = prod.Description.replace("\uFFFD", "'");
                        }
                    }).catch(err => {
                        console.error(err);
                    })
                } else {
                    LookupService.productCatagoryProducts(this.selectedCategoryId).then(res => {
                        this.products = res ?? [];

                        for(let prod of this.products) {
                            prod.Description = prod.Description.replace("\uFFFD", "'");
                        }
                    }).catch(err => {
                        console.error(err);
                    })
                }
            },
            handleAddProduct($event){
                this.$emit('productAdded', $event.row.data)
            },
            handleViewImage($event){
                const data = {
                    MfgId: $event.row.data.MfgId,
                    StockCode: $event.row.data.StockCode
                }

                //console.debug('Ready to get thumbnail: ', data)

                ProductService.getImage(data)
                    .then(res => {
                        this.thumbnailURL = res
                    })
            },
            handleViewSpecificProductInSmartCatalog($event){
                let product = $event.row.data;

                let data = {
                    manufacturerId: product.SmartCatalogMfgId,
                    dealerMfgId: product.MfgId,
                    dealerMfgCode: product.MfgCode,
                    product: product,
                };
                
                this.$emit('selected:manufacturer:product',data);
            },
            viewManufacturerCatalog(){
                let index = this.manufacturers.map(mfg => mfg.Id).indexOf(this.selectedManufacturerId)
                let dealerMfgId = this.manufacturers[index].DealerMfgId;
                let dealerMfgCode = this.manufacturers[index].DealerMfgCode;
                this.$emit('selected:manufacturer', this.selectedManufacturerId, dealerMfgId, dealerMfgCode);
            }
        },
        mounted(){
            this.getCatagories();
        },
        watch: {
            selectedManufacturerId: function () {
                this.datagridKey++;
            }
        }
    }
</script>

<style scoped lang="scss">
    .image {
        max-width: 150px;
        max-height: 150px;
    }

    .icon-btn {
        border: none;
        background-color: transparent;
        padding: 0px;
    }
    
    .thumbnail-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        min-height: 175px;
        border: 1px solid black;
        border-radius: 8px 8px;
        min-width: 100px;
        padding-left: 35px;
        margin-left: 10px;
    }

    .card {
        min-width: 300px;
        max-width: 700px;
        width: 80vw;
    }

    #smartCatelogCard {
        min-width: 900px;
        min-height: 700px;
    }

    .product-datagrid-wrapper {
        padding: 10px;
        margin-top: -50px;
    }

    .form-group {
        margin-bottom: 15px;

        select {
            -webkit-appearance: none;
            -moz-appearance: none;
            -o-appearance: none;
            /* no standardized syntax available, no ie-friendly solution available */
            width: 550px;
        }
        select + i.fa {
            float: right;
            margin-top: -26px;
            margin-right: 15px;
            /* this is so when you click on the chevron, your click actually goes on the dropdown menu */
            pointer-events: none;
            background:transparent;
            /* everything after this is just to cover up the original arrow */
            /* (for browsers that don't support the syntax used above) */
            /*background-color: #fff; inherits from form-control*/
            padding-right: 5px;
        }
    }

    .col-4 {
        z-index: 99;
    }
</style>
